<button
  class="followBtn vc-btn--social"
  [ngClass]="{subscribe: isFollow, 'followBtn--productPage': isProductPage}"
  (click)="toggleSubscribe($event)"
>
  <ng-container *ngIf="isProductPage; else textFollow">
    <vc-sprite-icons name="user-line" class="followBtn__iconMobile d-md-none"></vc-sprite-icons>
    <span *ngIf="isFollow; else unsubscribe" class="followBtn__block">
      <vc-sprite-icons name="checkmark" class="followBtn__block__icon"></vc-sprite-icons>
      <span class="d-none d-md-inline followBtn__block__text" i18n="@@FOLLOW_BTN.SUBSCRIBE">Follower</span>
    </span>
    <ng-template #unsubscribe>
      <span class="followBtn__block">
        <span class="followBtn__block__cross"></span>
        <span class="d-none d-md-inline followBtn__block__text" i18n="@@FOLLOW_BTN.FOLLOW">Follow</span>
      </span>
    </ng-template>
  </ng-container>

  <ng-template #textFollow>Follow</ng-template>
</button>
